import React from 'react';

import { Button, Flex, VStack } from '@chakra-ui/react';

import style from './FormModal.style';
import { FormModalProps } from './FormModal.type';

import { Icon, Modal, Text } from '@/components';
import useTranslation from '@/hooks/useTranslate';

function FormModal(props: FormModalProps) {
  const { t } = useTranslation();
  const {
    isOpen,
    isConfirmDisabled,
    title,
    description,
    isLoading,
    confirmText,
    cancelText,
    children,
    onCancel,
    onConfirm,
    isVillaModal,
    iconName,
    confirmDesignModal,
    icon,
    isVendor,
    showCloseButton,
    isVendorRating,
    deListingVendor,
    description2,
    isDLP,
  } = props;

  return (
    <Modal
      onClose={onCancel}
      isOpen={isOpen}
      showCloseButton={isVendor ? showCloseButton : false}
      closeOnOverlayClick={false}
      size={'5xl'}
      isVendorRating={isVendorRating}
    >
      <VStack sx={style.mainContainer}>
        {isVillaModal && !isVendor && (
          <Flex
            gap={deListingVendor ? '24px' : '16px'}
            flexDirection={'column'}
          >
            <Flex flexDirection={'row'} justifyContent={'center'}>
              {!deListingVendor ? (
                <Icon
                  name={iconName}
                  sx={
                    iconName != 'confirmTicked' ? style.Icon : style.IconTicked
                  }
                />
              ) : (
                <Icon name={iconName} sx={style.deListedVendorIcon} />
              )}
            </Flex>
            {title && !isVendor && <Text sx={style.title}>{title}</Text>}
          </Flex>
        )}
        {icon && !isVillaModal && (
          <Flex>
            <Icon name="arrows" sx={style.Icon} />
          </Flex>
        )}

        {title && isVendor && !isVillaModal ? (
          <Flex sx={{ width: '100%', gap: '10px' }}>
            <Icon name="vendorRating" sx={style.vendorIcon} />
            <Text sx={style.vendorTitle}>{title}</Text>
          </Flex>
        ) : title && !isVillaModal ? (
          <Text sx={style.title}>{title}</Text>
        ) : null}
        {description && !deListingVendor ? (
          <Text sx={!isVillaModal ? style.description : style.villaDescription}>
            {description}
          </Text>
        ) : (
          <Flex direction={'column'}>
            <Text sx={!isDLP ? style.deListedParagraph : style.dlpDescription}>
              {description}
            </Text>
            <Text sx={style.deListedParagraph}>{description2}</Text>
          </Flex>
        )}

        {children}

        {(cancelText || confirmText) && !isVendor && !isVillaModal ? (
          <Flex sx={style.buttonContainer}>
            {confirmText && (
              <Button
                isLoading={isLoading}
                onClick={onConfirm}
                sx={style.button}
                isDisabled={isConfirmDisabled}
              >
                {confirmText || t('portal_confirm')}
              </Button>
            )}
            {cancelText && (
              <Button
                variant="outline"
                isDisabled={isLoading}
                onClick={onCancel}
                sx={style.cancelButton}
              >
                {cancelText || t('portal_cancel')}
              </Button>
            )}
          </Flex>
        ) : (
          <Flex
            sx={
              isVillaModal
                ? style.buttonContainer
                : style.buttonContainerIsVendor
            }
          >
            {cancelText && (
              <Button
                variant="outline"
                isDisabled={isLoading}
                onClick={onCancel}
                sx={
                  !isVendor && !isDLP
                    ? style.cancelButton
                    : isDLP
                      ? style.isDLPCloseButton
                      : style.isVendorCancelButton
                }
              >
                {cancelText || t('portal_cancel')}
              </Button>
            )}
            {confirmText && !confirmDesignModal ? (
              <Button
                isLoading={isLoading}
                onClick={onConfirm}
                sx={style.button}
                isDisabled={isConfirmDisabled}
              >
                {confirmText || t('portal_confirm')}
              </Button>
            ) : (
              <Button
                isLoading={isLoading}
                onClick={onConfirm}
                sx={style.button}
                isDisabled={isConfirmDisabled}
              >
                {confirmText}
              </Button>
            )}
          </Flex>
        )}
      </VStack>
    </Modal>
  );
}

export default FormModal;
